import React, { useState } from "react";
import { Users, BookOpen, HeartHandshake, Settings2 } from "lucide-react";
import StudentsPanel from "../components/admin/StudentsPanel";
import CoursesPanel from "../components/admin/CoursesPanel";
import FamiliesPanel from "../components/admin/FamiliesPanel";
import SettingsPanel from "../components/admin/SettingsPanel";

const TABS = [
  ["students", "Alumnos", Users, StudentsPanel],
  ["courses", "Cursos", BookOpen, CoursesPanel],
  ["families", "Familias", HeartHandshake, FamiliesPanel],
  ["settings", "Configuración", Settings2, SettingsPanel],
];

export default function AdminDashboard() {
  const [tab, setTab] = useState("students");
  const Panel = TABS.find((t) => t[0] === tab)[3];
  return (
    <div className="space-y-6">
      <div>
        <span className="inline-block text-[10px] font-semibold tracking-widest text-[#4F6B47] px-2 py-1 border border-[#4F6B47]/30 rounded-full">
          PANEL ADMIN
        </span>
        <h1 className="mt-3 font-serif text-3xl font-bold">Gestión académica</h1>
      </div>
      <nav className="-mx-5 px-5 overflow-x-auto">
        <div className="flex gap-2 w-max">
          {TABS.map(([key, text, Icon]) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-[12px] font-semibold border transition-colors ${
                tab === key ? "bg-[#132C44] text-[#F6EFDF] border-[#132C44]" : "bg-white/70 border-[#132C44]/15 hover:border-[#132C44]/40"
              }`}
              data-testid={`eid-admin-tab-${key}`}
            >
              <Icon className="h-3.5 w-3.5" /> {text}
            </button>
          ))}
        </div>
      </nav>
      <Panel />
    </div>
  );
}
